(() => {
  const root = document.querySelector('#KisskindProductExperience')
    || document.querySelector('#shopify-section-kisskind-site-final-v9')
    || document.querySelector('#shopify-section-kisskind-site-final-v10')
    || document.querySelector('#shopify-section-kisskind-site-final-v11')
    || document.querySelector('#shopify-section-kisskind-site-final-v12')
    || document.querySelector('#shopify-section-kisskind-site-final-v13');
  if (!root) return;

  const enhancementSource = document.querySelector('#KisskindPurchaseEnhancementsSource');
  const variantDataElement = enhancementSource?.querySelector('#KisskindVariantData');
  let variantRecords = [];
  try { variantRecords = JSON.parse(variantDataElement?.textContent || '[]'); }
  catch (_) { variantRecords = []; }

  const prepurchaseFaq = enhancementSource?.querySelector('.prepurchase-faq');
  const mobileBuyBar = enhancementSource?.querySelector('.mobile-buy-bar');
  const reviewsSection = root.querySelector('.reviews');
  const oldShopLink = reviewsSection?.querySelector(':scope > a[href="#top"]');
  if (prepurchaseFaq && reviewsSection) {
    if (oldShopLink) oldShopLink.insertAdjacentElement('beforebegin', prepurchaseFaq);
    else reviewsSection.appendChild(prepurchaseFaq);
  }
  if (mobileBuyBar) root.appendChild(mobileBuyBar);
  enhancementSource?.remove();

  let colorIndex = 0;
  let sizeOption = '';
  let quantity = 1;

  const image = root.querySelector('.product-image');
  const galleryLabel = root.querySelector('.gallery-size');
  const price = root.querySelector('.price');
  const payment = root.querySelector('.pay-note');
  const guidance = root.querySelector('.size-guidance');
  const quantityText = root.querySelector('.quantity span');
  const addButton = root.querySelector('.add');
  const buyNowButton = root.querySelector('.express');
  const nativeForm = root.querySelector('#KisskindNativeCartFallback');
  const nativeVariantInput = nativeForm?.querySelector('input[name="id"]');
  const nativeQuantityInput = nativeForm?.querySelector('input[name="quantity"]');
  const nativeReturnInput = nativeForm?.querySelector('input[name="return_to"]');
  const thumbButtons = [...root.querySelectorAll('button.thumb')];
  const swatches = [...root.querySelectorAll('.buy-panel .swatch')];
  const sizeButtons = [...root.querySelectorAll('.buy-panel .size-option')];
  const initialVariantId = Number(root.dataset.selectedVariantId || 0);
  const initialVariant = variantRecords.find((variant) => Number(variant.id) === initialVariantId)
    || variantRecords.find((variant) => variant.available)
    || variantRecords[0]
    || null;
  sizeOption = initialVariant?.option1 || sizeButtons[0]?.dataset.optionValue || '';
  colorIndex = Math.max(0, swatches.findIndex((button) => button.dataset.optionValue === initialVariant?.option2));
  const finalSwatches = [...root.querySelectorAll('.final-swatch')];
  const finalSizeButtons = [...root.querySelectorAll('.final-size-option')];
  const finalSelection = root.querySelector('.final-selection');
  const finalPrice = root.querySelector('.final-price');
  const finalInventory = root.querySelector('.final-inventory');
  const finalAddButton = root.querySelector('.final-add');
  const finalBuyNowButton = root.querySelector('.final-express');
  const mobileSelection = root.querySelector('.mobile-selection');
  const mobilePrice = root.querySelector('.mobile-price');
  const mobileAddButton = root.querySelector('.mobile-add');
  const menuButton = root.querySelector('.menu-toggle');
  const mobileMenu = root.querySelector('#mobile-menu');
  const reviewBadge = root.querySelector('#KisskindReviewBadgeSource');
  const customerReviews = root.querySelector('#KisskindCustomerReviewsSource');
  const footer = root.querySelector('footer');

  if (reviewBadge && price) {
    price.insertAdjacentElement('afterend', reviewBadge);
    reviewBadge.hidden = false;
  }
  if (customerReviews && footer) {
    footer.insertAdjacentElement('beforebegin', customerReviews);
    customerReviews.hidden = false;
  }

  function positionShopifyChatAboveMobileBuyBar() {
    const chatRoot = document.querySelector('shopify-chat')?.shadowRoot;
    if (!chatRoot) return false;
    if (!chatRoot.querySelector('#KisskindMobileChatOffset')) {
      const style = document.createElement('style');
      style.id = 'KisskindMobileChatOffset';
      style.textContent = '@media (max-width: 900px) { .activator-nudge { bottom: calc(84px + env(safe-area-inset-bottom, 0px)) !important; } }';
      chatRoot.appendChild(style);
    }
    return true;
  }

  if (!positionShopifyChatAboveMobileBuyBar()) {
    const chatObserver = new MutationObserver(() => {
      if (positionShopifyChatAboveMobileBuyBar()) chatObserver.disconnect();
    });
    chatObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => chatObserver.disconnect(), 15000);
  }

  function selectedColorButton() {
    return swatches[colorIndex] || null;
  }

  function displaySize(value) {
    return String(value || '').replace(/(\d+)oz/i, '$1 oz');
  }

  function displayColor() {
    const button = selectedColorButton();
    return button?.dataset.displayName || button?.dataset.optionValue || '';
  }

  function getSelectedVariant() {
    const colorOption = selectedColorButton()?.dataset.optionValue || '';
    return variantRecords.find((variant) => variant.option1 === sizeOption && variant.option2 === colorOption) || null;
  }

  function formatMoney(cents) {
    const currency = root.dataset.currency || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency,
      }).format(Number(cents || 0) / 100);
    } catch (_) {
      return `${currency} ${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  }

  function syncNativeForm(checkout = false) {
    const variant = getSelectedVariant();
    if (nativeVariantInput) nativeVariantInput.value = variant ? String(variant.id) : '';
    if (nativeQuantityInput) nativeQuantityInput.value = String(quantity);
    if (nativeReturnInput) nativeReturnInput.value = checkout ? '/checkout' : '/cart';
  }

  function syncMainPurchaseState() {
    const variant = getSelectedVariant();
    const formattedPrice = variant ? formatMoney(variant.price) : 'Unavailable';
    if (price) price.textContent = formattedPrice;
    if (payment) payment.textContent = variant
      ? `or 4 interest-free payments of ${formatMoney(Math.ceil(Number(variant.price) / 4))}`
      : 'This combination is unavailable.';
    if (guidance) guidance.textContent = sizeOption === '24oz'
      ? 'More room for ice and longer days away from home.'
      : 'A lighter everyday size for coffee, desks and shorter trips.';
    const specs = root.querySelector('.accordion:first-child p');
    if (specs) specs.textContent = `${displaySize(sizeOption)} selected · Cup-holder friendly tapered base · Hidden reusable straw · Leak-resistant slide-lock lid · Keeps drinks cold for up to 12 hours.`;
  }

  function syncEnhancementState() {
    const variant = getSelectedVariant();
    const sizeName = displaySize(sizeOption);
    const colorName = displayColor();
    const selection = `${colorName} · ${sizeName}`;
    const compactSelection = `${sizeName} · ${colorName}`;
    const formattedPrice = variant ? formatMoney(variant.price) : 'Unavailable';
    const available = Boolean(variant?.available);
    if (finalSelection) finalSelection.textContent = selection;
    if (finalPrice) finalPrice.textContent = formattedPrice;
    if (mobileSelection) mobileSelection.textContent = compactSelection;
    if (mobilePrice) mobilePrice.textContent = formattedPrice;
    finalSwatches.forEach((button, index) => {
      button.classList.toggle('selected', index === colorIndex);
      button.setAttribute('aria-pressed', String(index === colorIndex));
    });
    finalSizeButtons.forEach((button) => {
      const selected = button.dataset.optionValue === sizeOption;
      button.classList.toggle('selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    if (finalInventory) {
      finalInventory.classList.toggle('is-sold-out', !available);
      const status = finalInventory.querySelector('strong');
      if (status) status.textContent = available ? 'In stock' : 'Unavailable';
    }
    [addButton, buyNowButton, finalAddButton, finalBuyNowButton, mobileAddButton].forEach((button) => {
      if (button) button.disabled = !available;
    });
  }

  menuButton?.addEventListener('click', () => {
    const willOpen = mobileMenu?.hidden !== false;
    if (mobileMenu) mobileMenu.hidden = !willOpen;
    menuButton.setAttribute('aria-expanded', String(willOpen));
    menuButton.textContent = willOpen ? 'Close' : 'Menu';
  });
  mobileMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
    mobileMenu.hidden = true;
    menuButton?.setAttribute('aria-expanded', 'false');
    if (menuButton) menuButton.textContent = 'Menu';
  }));

  function chooseColor(index) {
    colorIndex = Math.max(0, index);
    const colorNameValue = displayColor();
    const thumbImage = thumbButtons[colorIndex]?.querySelector('img');
    if (thumbImage && image) {
      image.src = thumbImage.src;
      image.alt = `${colorNameValue} Kisskind iced coffee tumbler`;
    }
    if (galleryLabel) galleryLabel.textContent = `20 + 24 oz · ${colorNameValue}`;
    thumbButtons.forEach((button, i) => {
      button.classList.toggle('active', i === colorIndex);
      button.setAttribute('aria-pressed', String(i === colorIndex));
    });
    swatches.forEach((button, i) => {
      button.classList.toggle('selected', i === colorIndex);
      button.setAttribute('aria-pressed', String(i === colorIndex));
    });
    const colorName = root.querySelector('.option-head strong');
    if (colorName) colorName.textContent = colorNameValue;
    syncNativeForm();
    syncMainPurchaseState();
    syncEnhancementState();
  }

  thumbButtons.forEach((button, index) => button.addEventListener('click', () => chooseColor(index)));
  swatches.forEach((button, index) => button.addEventListener('click', () => chooseColor(index)));
  finalSwatches.forEach((button, index) => button.addEventListener('click', () => chooseColor(index)));

  function chooseSize(index) {
    const selectedButton = sizeButtons[index] || sizeButtons[0] || null;
    sizeOption = selectedButton?.dataset.optionValue || '';
    sizeButtons.forEach((item) => {
      const selected = item === selectedButton;
      item.classList.toggle('selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
    const sizeName = root.querySelector('.size-head strong');
    if (sizeName) sizeName.textContent = displaySize(sizeOption);
    syncNativeForm();
    syncMainPurchaseState();
    syncEnhancementState();
  }

  sizeButtons.forEach((button, index) => button.addEventListener('click', () => chooseSize(index)));
  finalSizeButtons.forEach((button, index) => button.addEventListener('click', () => chooseSize(index)));

  root.querySelector('.quantity button:first-child')?.addEventListener('click', () => {
    quantity = Math.max(1, quantity - 1);
    if (quantityText) quantityText.textContent = String(quantity);
    syncNativeForm();
  });
  root.querySelector('.quantity button:last-child')?.addEventListener('click', () => {
    quantity += 1;
    if (quantityText) quantityText.textContent = String(quantity);
    syncNativeForm();
  });

  const accordionBodies = {
    Specs: '20 oz capacity · 8.2 in tall · 3.3 in wide · Cup-holder friendly tapered base · Hidden reusable straw · Leak-resistant slide-lock lid · Keeps drinks cold for up to 12 hours.',
    Materials: 'Ceramic-coated 18/8 stainless steel interior · Double-wall vacuum insulation · BPA-free locking lid · Food-grade silicone straw, mouthpiece and leak-resistant seal.',
    'Care Guide': 'Wash before first use. Hand wash the lid, silicone straw and seal. The stainless steel cup is top-rack dishwasher safe. Remove the seal for deep cleaning and dry every part completely before reassembly.',
  };
  [...root.querySelectorAll('.accordion')].forEach((accordion) => {
    const button = accordion.querySelector('button');
    if (!button) return;
    const title = button.childNodes[0]?.textContent?.trim() || '';
    let body = accordion.querySelector('p');
    if (!body) {
      body = document.createElement('p');
      body.textContent = accordionBodies[title] || '';
      body.hidden = true;
      accordion.appendChild(body);
    }
    body.textContent = accordionBodies[title] || body.textContent;
    if (title !== 'Specs') {
      button.setAttribute('aria-expanded', 'false');
      body.hidden = true;
      const initialIcon = button.querySelector('span');
      if (initialIcon) initialIcon.textContent = '+';
    }
    button.addEventListener('click', () => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      [...root.querySelectorAll('.accordion')].forEach((item) => {
        const itemButton = item.querySelector('button');
        const itemBody = item.querySelector('p');
        if (!itemButton || !itemBody) return;
        itemButton.setAttribute('aria-expanded', 'false');
        itemBody.hidden = true;
        const itemIcon = itemButton.querySelector('span');
        if (itemIcon) itemIcon.textContent = '+';
      });
      if (!isOpen) {
        button.setAttribute('aria-expanded', 'true');
        body.hidden = false;
        const icon = button.querySelector('span');
        if (icon) icon.textContent = '−';
      }
    });
  });

  async function addToCart(checkout) {
    const variant = getSelectedVariant();
    if (!variant || !variant.available) throw new Error('This selection is unavailable.');
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variant.id), quantity }] }),
    });
    if (!response.ok) throw new Error('Unable to add this item to the cart.');
    window.location.href = checkout ? '/checkout' : '/cart';
  }

  function submitNativeFallback(checkout) {
    if (!nativeForm || !getSelectedVariant()) return false;
    syncNativeForm(checkout);
    nativeForm.submit();
    return true;
  }

  async function runPurchase(button, checkout) {
    if (!button || button.disabled) return;
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = checkout ? 'Opening checkout…' : 'Adding…';
    try { await addToCart(checkout); }
    catch (_) {
      if (submitNativeFallback(checkout)) return;
      button.disabled = false;
      button.textContent = 'Try again';
      window.setTimeout(() => { button.textContent = originalText; }, 1800);
    }
  }

  addButton?.addEventListener('click', () => runPurchase(addButton, false));
  buyNowButton?.addEventListener('click', () => runPurchase(buyNowButton, true));
  finalAddButton?.addEventListener('click', () => runPurchase(finalAddButton, false));
  finalBuyNowButton?.addEventListener('click', () => runPurchase(finalBuyNowButton, true));
  mobileAddButton?.addEventListener('click', () => runPurchase(mobileAddButton, false));

  const mainPurchase = root.querySelector('.purchase-row');
  const finalPurchase = root.querySelector('.final-purchase');
  let stickyFrame = 0;
  function updateMobileBar() {
    if (!mobileBuyBar || !mainPurchase) return;
    const purchaseBottom = mainPurchase.getBoundingClientRect().bottom + window.scrollY;
    const finalRect = finalPurchase?.getBoundingClientRect();
    const finalVisible = Boolean(finalRect && finalRect.top < window.innerHeight && finalRect.bottom > 0);
    const shouldShow = window.matchMedia('(max-width: 900px)').matches
      && window.scrollY > purchaseBottom + 24
      && !finalVisible;
    mobileBuyBar.classList.toggle('is-visible', shouldShow);
    mobileBuyBar.setAttribute('aria-hidden', String(!shouldShow));
  }
  function requestMobileBarUpdate() {
    if (stickyFrame) return;
    stickyFrame = window.requestAnimationFrame(() => {
      stickyFrame = 0;
      updateMobileBar();
    });
  }
  window.addEventListener('scroll', requestMobileBarUpdate, { passive: true });
  window.addEventListener('resize', requestMobileBarUpdate);
  window.addEventListener('load', requestMobileBarUpdate, { once: true });
  chooseColor(colorIndex);
  chooseSize(Math.max(0, sizeButtons.findIndex((button) => button.dataset.optionValue === sizeOption)));
  updateMobileBar();
})();
